// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB3aWR0aD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM4IDEyLjgzbC0yLjgzLTIuODMtMTEuMTcgMTEuMTctMTEuMTctMTEuMTctMi44MyAyLjgzIDExLjE3IDExLjE3LTExLjE3IDExLjE3IDIuODMgMi44MyAxMS4xNy0xMS4xNyAxMS4xNyAxMS4xNyAyLjgzLTIuODMtMTEuMTctMTEuMTd6Ii8+PHBhdGggZD0iTTAgMGg0OHY0OGgtNDh6IiBmaWxsPSJub25lIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-css {
  font-size: 15px;
  line-height: 2.1;
}

::-webkit-scrollbar {
  width: 8px;
  height: 2px;
}

::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 12px;
}

::-webkit-scrollbar-track {
  margin-block: 1rem;
}


.choose_file {
  width: 220px;
  background: rgb(249, 252, 248);
  border: none;
  outline: none;
  box-shadow: 1px 4px 1px whitesmoke;
  border-radius: 10px;
}
::-webkit-file-upload-button {
  cursor: pointer;
  border: none;
  background: #048129;
  border-radius: 10px;
  height: 40px;
  color: white;
  width: 100px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  margin-right: 15px;
}
::-webkit-file-upload-button:hover {
  background-color: #056124;
}

/* -------------------------------------------------------------------------------------------- */

.files-dropzone-list {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding: 10px;
  border: 1px dashed #d3d3d3;
  cursor: pointer;
}

.files-buttons {
  border-top: 1px solid #d3d3d3;
  cursor: pointer;
}
.files-button-submit {
  display: inline-block;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 50%;
  box-sizing: border-box;
  border-right: 1px solid #d3d3d3;
}
.files-button-submit:before {
  content: "Submit";
}
.files-button-clear {
  display: inline-block;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 50%;
  box-sizing: border-box;
}
.files-button-clear:before {
  content: "Clear";
}
.files-list {
  width: 600px;
}
.files-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.files-list li:last-child {
  border: none;
}
.files-list-item {
  height: 60px;
  padding: 10px 0px 10px 10px;
  /*border-bottom: 1px solid #D3D3D3;*/
}
.files-list-item-content {
  float: left;
  padding-top: 5px;
  padding-left: 10px;
  width: calc(100% - 130px);
}
.files-list-item-content-item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.files-list-item-content-item-1 {
  font-size: 20px;
  line-height: 30px;
}
.files-list-item-content-item-2 {
  font-size: 16px;
  line-height: 20px;
}
.files-list-item-preview {
  height: 60px;
  width: 60px;
  float: left;
}
.files-list-item-preview-image {
  height: 100%;
  width: 100%;
}
.files-list-item-preview-extension {
  text-align: center;
  line-height: 60px;
  color: #fff;
  background-color: #d3d3d3;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
}
.files-list-item-remove {
  height: 60px;
  width: 60px;
  float: right;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat center center;
  background-size: 30px 30px;
}
.files-list-item-remove-image {
  height: 30px;
  width: 30px;
  margin-top: 15px;
  margin-right: 10px;
  float: right;
}

/* GALLERY */
/* ================== */

.files-dropzone-gallery {
  padding: 10px;
  border: 1px dashed #d3d3d3;
  min-height: 300px;
  width: 500px;
}
.files-gallery-item {
  height: 80px;
  margin: 5px;
}

.files-dropzone-active {
  border: 1px solid lightgreen;
  color: lightgreen;
}

.form-control:focus {
  border-color: skyblue;
  /* border-color:skyblue; */
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.075) inset,
    0px 0px 0px rgba(255, 100, 255, 0.5);
}
.error {
  color: red;
}

.alert-dismissible .close {
  position: absolute;
  top: -13px;
  right: 0;
  padding: .75rem 1.25rem;
  color: inherit;
}

.subscriptionStatus-error {
  color: white;
  background: #ef5350;
  padding: 5%;
  border-radius: 5px;
  border: 1px solid #ef5350;
}

.subscriptionStatus-warning {
  color: white;
  background: #ff9800;
  padding: 5%;
  border-radius: 5px;
  border: 1px solid #ff9800;
}

.subscriptionStatus-success {
  color: white;
  background: #4caf50;
  padding: 5%;
  border-radius: 5px;
  border: 1px solid #4caf50;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA,iGAAiG;;AAEjG;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf;2BACyB;EACzB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,YAAY;AACZ,uBAAuB;;AAEvB;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B;wCACsC;AACxC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".select-css {\n  font-size: 15px;\n  line-height: 2.1;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 2px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: gray;\n  border-radius: 12px;\n}\n\n::-webkit-scrollbar-track {\n  margin-block: 1rem;\n}\n\n\n.choose_file {\n  width: 220px;\n  background: rgb(249, 252, 248);\n  border: none;\n  outline: none;\n  box-shadow: 1px 4px 1px whitesmoke;\n  border-radius: 10px;\n}\n::-webkit-file-upload-button {\n  cursor: pointer;\n  border: none;\n  background: #048129;\n  border-radius: 10px;\n  height: 40px;\n  color: white;\n  width: 100px;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n  margin-right: 15px;\n}\n::-webkit-file-upload-button:hover {\n  background-color: #056124;\n}\n\n/* -------------------------------------------------------------------------------------------- */\n\n.files-dropzone-list {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n  padding: 10px;\n  border: 1px dashed #d3d3d3;\n  cursor: pointer;\n}\n\n.files-buttons {\n  border-top: 1px solid #d3d3d3;\n  cursor: pointer;\n}\n.files-button-submit {\n  display: inline-block;\n  text-align: center;\n  height: 40px;\n  line-height: 40px;\n  width: 50%;\n  box-sizing: border-box;\n  border-right: 1px solid #d3d3d3;\n}\n.files-button-submit:before {\n  content: \"Submit\";\n}\n.files-button-clear {\n  display: inline-block;\n  text-align: center;\n  height: 40px;\n  line-height: 40px;\n  width: 50%;\n  box-sizing: border-box;\n}\n.files-button-clear:before {\n  content: \"Clear\";\n}\n.files-list {\n  width: 600px;\n}\n.files-list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.files-list li:last-child {\n  border: none;\n}\n.files-list-item {\n  height: 60px;\n  padding: 10px 0px 10px 10px;\n  /*border-bottom: 1px solid #D3D3D3;*/\n}\n.files-list-item-content {\n  float: left;\n  padding-top: 5px;\n  padding-left: 10px;\n  width: calc(100% - 130px);\n}\n.files-list-item-content-item {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.files-list-item-content-item-1 {\n  font-size: 20px;\n  line-height: 30px;\n}\n.files-list-item-content-item-2 {\n  font-size: 16px;\n  line-height: 20px;\n}\n.files-list-item-preview {\n  height: 60px;\n  width: 60px;\n  float: left;\n}\n.files-list-item-preview-image {\n  height: 100%;\n  width: 100%;\n}\n.files-list-item-preview-extension {\n  text-align: center;\n  line-height: 60px;\n  color: #fff;\n  background-color: #d3d3d3;\n  font-size: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-left: 5px;\n  padding-right: 5px;\n  box-sizing: border-box;\n}\n.files-list-item-remove {\n  height: 60px;\n  width: 60px;\n  float: right;\n  cursor: pointer;\n  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB3aWR0aD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM4IDEyLjgzbC0yLjgzLTIuODMtMTEuMTcgMTEuMTctMTEuMTctMTEuMTctMi44MyAyLjgzIDExLjE3IDExLjE3LTExLjE3IDExLjE3IDIuODMgMi44MyAxMS4xNy0xMS4xNyAxMS4xNyAxMS4xNyAyLjgzLTIuODMtMTEuMTctMTEuMTd6Ii8+PHBhdGggZD0iTTAgMGg0OHY0OGgtNDh6IiBmaWxsPSJub25lIi8+PC9zdmc+)\n    no-repeat center center;\n  background-size: 30px 30px;\n}\n.files-list-item-remove-image {\n  height: 30px;\n  width: 30px;\n  margin-top: 15px;\n  margin-right: 10px;\n  float: right;\n}\n\n/* GALLERY */\n/* ================== */\n\n.files-dropzone-gallery {\n  padding: 10px;\n  border: 1px dashed #d3d3d3;\n  min-height: 300px;\n  width: 500px;\n}\n.files-gallery-item {\n  height: 80px;\n  margin: 5px;\n}\n\n.files-dropzone-active {\n  border: 1px solid lightgreen;\n  color: lightgreen;\n}\n\n.form-control:focus {\n  border-color: skyblue;\n  /* border-color:skyblue; */\n  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.075) inset,\n    0px 0px 0px rgba(255, 100, 255, 0.5);\n}\n.error {\n  color: red;\n}\n\n.alert-dismissible .close {\n  position: absolute;\n  top: -13px;\n  right: 0;\n  padding: .75rem 1.25rem;\n  color: inherit;\n}\n\n.subscriptionStatus-error {\n  color: white;\n  background: #ef5350;\n  padding: 5%;\n  border-radius: 5px;\n  border: 1px solid #ef5350;\n}\n\n.subscriptionStatus-warning {\n  color: white;\n  background: #ff9800;\n  padding: 5%;\n  border-radius: 5px;\n  border: 1px solid #ff9800;\n}\n\n.subscriptionStatus-success {\n  color: white;\n  background: #4caf50;\n  padding: 5%;\n  border-radius: 5px;\n  border: 1px solid #4caf50;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
